import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

/* ------------------------------------------------------------- */
/*  Translation dictionary (PL → EN reverse lookup)              */
/*  Any Polish string not present here falls back to itself.     */
/* ------------------------------------------------------------- */

const EN = {
  /* Nav */
  'Menu': 'Menu',
  'Praliny': 'Pralines',
  'Ciasta i torty na zamówienie': 'Cakes & Tarts on Order',
  'Kontakt': 'Contact',
  'Strona główna.': 'Home.',

  /* Hero */
  'Wrocław · ul. Więzienna 31 · od 2004': 'Wrocław · Więzienna 31 · since 2004',
  'Najstarsza Czekoladziarnia': "Wrocław's Oldest",
  'we Wrocławiu.': 'Chocolaterie.',
  'Od ponad 20 lat w sercu Starego Miasta łączymy miłość do czekolady z rzemieślniczą pasją. Słyniemy z gęstej, prawdziwej gorącej czekolady – serwowanej klasycznie lub z autorskimi i sezonowymi dodatkami.':
    "For over 20 years, in the heart of Wrocław's Old Town, we've combined our love for chocolate with artisan passion. We are renowned for our thick, authentic hot chocolate — served classic or with signature and seasonal add-ons.",
  'Naszą największą dumą są ręcznie robione praliny, z których każda to małe dzieło sztuki. ':
    'Our greatest pride is our hand-made pralines — each one a small work of art. ',
  'W menu znajdziecie również pozycje bezglutenowe.':
    'The menu also features gluten-free options.',
  ' Odwiedź nas, by skosztować wyśmienitych deserów, znaleźć idealny prezent i stworzyć niezapomniane, czekoladowe wspomnienia.':
    ' Visit us to taste exquisite desserts, find the perfect gift and create unforgettable chocolate memories.',
  'Zobacz menu': 'Explore menu',
  'Zamówienia indywidualne': 'Custom orders',

  /* Menu section */
  'Karta · 2026': 'Menu · 2026',
  'Menu, które zmienia się ': 'A menu that changes ',
  'jak sezony.': 'with the seasons.',
  'Część pozycji jest stała — klasyczna gorąca czekolada, brownie z wiśniami, sygnaturowa pralina „Esencja Czekolady". Reszta podąża za sezonem.':
    'Some items are timeless — the classic hot chocolate, cherry brownie, and our signature praline "Chocolate Essence". The rest follows the seasons.',
  'ceny: mała / duża': 'prices: small / large',

  /* Menu — category labels & taglines & descriptions */
  'Czekolada na gorąco': 'Hot chocolate',
  'Aksamit w filiżance': 'Velvet in a cup',
  'Nasza specjalność. Prawdziwa, gęsta czekolada w kilkunastu odsłonach — od klasycznej po sezonową lotus biscoff.':
    'Our specialty. Thick, authentic chocolate in over a dozen variations — from classic to seasonal Lotus Biscoff.',

  'Czekolada z kawą': 'Chocolate with coffee',
  'Espresso spotyka kakao': 'Espresso meets cocoa',
  'Nasze autorskie połączenia gorącej czekolady i kawy — dla tych, którzy nie chcą wybierać.':
    "Our signature blends of hot chocolate and coffee — for those who don't want to choose.",

  'Kawa': 'Coffee',
  'Ciepła klasyka': 'Warm classics',
  'Świeżo palona kawa parzona na miejscu — od espresso po smakowe latte.':
    'Freshly roasted coffee brewed on-site — from espresso to flavoured lattes.',

  'Kawa na zimno': 'Iced coffee',
  'Mroźna przerwa': 'A frosty break',
  'Kawy mrożone z autorskimi kremami, syropami i lodami — na upalne dni i nie tylko.':
    'Iced coffees with signature creams, syrups and ice cream — for hot days and beyond.',

  'Matcha': 'Matcha',
  'Zielona energia': 'Green energy',
  'Prawdziwa japońska matcha na lodzie, w kilku owocowych odsłonach.':
    'Authentic Japanese matcha on ice, in several fruity variations.',

  'Zimne napoje': 'Cold drinks',
  'Lemoniady i klasyki': 'Lemonades & classics',
  'Domowe lemoniady komponowane na miejscu oraz klasyczne napoje bezalkoholowe.':
    'House-made lemonades composed on-site and classic soft drinks.',

  'Desery lodowe': 'Ice cream desserts',
  'Chłodne słodkości': 'Cold sweetness',
  'Deserowe kompozycje z lodów, bitej śmietany i sezonowych dodatków — o szczegóły zapytaj obsługę.':
    'Dessert compositions with ice cream, whipped cream and seasonal add-ons — please ask our staff for details.',

  'Koktajle': 'Cocktails',
  'Wieczorowa nuta': 'An evening note',
  'Autorskie koktajle na bazie Aperolu, Prosecco i Malibu — komponowane w kawiarni.':
    'Signature cocktails based on Aperol, Prosecco and Malibu — mixed at the café.',

  'Herbaty': 'Teas',
  'Imbryki liściaste': 'Loose-leaf teapots',
  'Sypane herbaty parzone w imbryczkach.': 'Loose-leaf teas brewed in teapots.',
  'imbryczek 450 ml · 16 zł   |   900 ml · 19 zł   |   Herbata zimowa 200 ml · 24 zł':
    'teapot 450 ml · 16 zł   |   900 ml · 19 zł   |   Winter tea 200 ml · 24 zł',
  'Herbata zimowa (200 ml)': 'Winter tea (200 ml)',
  'aromatyczna czarna herbata podawana z syropem cynamonowo-pomarańczowym lub imbirowo-miodowym i dodatkami.':
    'aromatic black tea served with cinnamon-orange or ginger-honey syrup and add-ons.',

  'Napary rozgrzewające': 'Warming infusions',
  'Jesienne purée i korzenne syropy': 'Autumn purées and spiced syrups',
  'Autorskie, aromatyczne napary podawane na gorąco — jesienny gest dla zmarzniętych gości.':
    'Signature, aromatic infusions served hot — an autumn gesture for chilled guests.',
  'Napar malina': 'Raspberry infusion',
  'purée malina, syrop róża, cytryna, imbir, pomarańcza': 'raspberry purée, rose syrup, lemon, ginger, orange',
  'Napar morela-pigwa': 'Apricot-quince infusion',
  'purée morela, syrop pigwa, sok z cytryny, goździki, cynamon': 'apricot purée, quince syrup, lemon juice, cloves, cinnamon',
  'Napar rokitnik': 'Sea buckthorn infusion',
  'purée rokitnik, syrop wiśnia, syrop kasztan, rozmaryn, żurawina': 'sea buckthorn purée, cherry syrup, chestnut syrup, rosemary, cranberry',
  'Napar mango': 'Mango infusion',
  'purée mango, syrop pigwa, goździki, cytryna': 'mango purée, quince syrup, cloves, lemon',
  'Lemoniada brzoskwiniowa na gorąco': 'Warm peach lemonade',
  'purée brzoskwiniowe, sok z cytryny, syrop imbirowy, jabłko, cytryna': 'peach purée, lemon juice, ginger syrup, apple, lemon',

  'Pumpkin spice latte': 'Pumpkin spice latte',
  'Latte orzechowe': 'Hazelnut latte',
  'Lotus Biscoff latte': 'Lotus Biscoff latte',

  'Z bitą śmietaną i piankami': 'With whipped cream and marshmallows',
  'Szarlotka z bitą śmietaną': 'Apple pie with whipped cream',
  'Cynamonowa śliwka': 'Cinnamon plum',
  'Z konfiturą grzaniec': 'With mulled-wine jam',
  'Bananowa': 'Banana',

  'Grzaniec': 'Mulled wine',
  'Grzaniec bezalkoholowy': 'Non-alcoholic mulled drink',

  'Zestaw testowy': 'Tasting set',
  'Skomponuj własną degustację': 'Compose your own tasting',
  'Autorski zestaw pięciu gorących czekolad do wyboru — idealny na pierwszą wizytę albo prezent-doświadczenie.':
    'A signature set of five hot chocolates of your choice — perfect for a first visit or an experience gift.',
  'Zestaw testowy gorących czekolad': 'Hot chocolate tasting set',
  'Wybierasz 5 z: z serem pleśniowym, z wiśniami, z malinami, z Advokatem, chocoffee, ze słonym karmelem, z bitą śmietaną, biała, pistacjowa, Kinder Bueno, klasyczna, rafaello.':
    'Pick any 5 from: blue cheese, cherry, raspberry, Advocaat, chocoffee, salted caramel, whipped cream, white, pistachio, Kinder Bueno, classic, Raffaello.',
  'Oznacz nas w relacji na Instagramie, TikToku lub Facebooku i odbierz 10% zniżki na kolejną wizytę.':
    'Tag us in a story on Instagram, TikTok or Facebook and receive 10% off your next visit.',

  /* Menu item names — hot chocolate */
  'Klasyczna': 'Classic',
  'Z wiśniami': 'With cherries',
  'Z malinami': 'With raspberries',
  'Z gruszką': 'With pear',
  'Z bitą śmietaną': 'With whipped cream',
  'Z serem pleśniowym': 'With blue cheese',
  'Z gałką lodów': 'With a scoop of ice cream',
  'Z gałką lodów i owocami': 'With ice cream and fruit',
  'Biała czekolada klasyczna': 'White chocolate classic',
  'Biała czekolada z bitą śmietaną i owocami': 'White chocolate with whipped cream and fruit',
  'Pistacjowa z malinową posypką': 'Pistachio with raspberry sprinkle',
  'Ze słonym karmelem': 'With salted caramel',
  'Kinder Bueno': 'Kinder Bueno',
  'Z likierem Bailey\u2019s': "With Bailey's liqueur",
  'Z Advokatem': 'With Advocaat',
  'Rafaello': 'Raffaello',
  'Lotus Biscoff': 'Lotus Biscoff',

  /* Chocoffee etc. */
  'Chocoffee': 'Chocoffee',
  'espresso z czekoladą': 'espresso with chocolate',
  'Chocoffee z gałką lodów': 'Chocoffee with a scoop of ice cream',
  'Choco latte': 'Choco latte',
  'latte z czekoladą zamiast kawy': 'latte with chocolate instead of coffee',
  'Chocoffee latte': 'Chocoffee latte',
  'latte z czekoladą i kawą': 'latte with chocolate and coffee',

  /* Coffee */
  'Americano': 'Americano',
  'Americano white': 'Americano white',
  'Espresso / doppio / macchiato': 'Espresso / doppio / macchiato',
  'Cappuccino / flat white': 'Cappuccino / flat white',
  'Cappuccino pistacjowe': 'Pistachio cappuccino',
  'Cappuccino z likierem Bailey\u2019s': "Cappuccino with Bailey's liqueur",
  'Latte': 'Latte',
  'Latte ze słonym karmelem': 'Latte with salted caramel',
  'Latte różane': 'Rose latte',
  'Latte lawendowe': 'Lavender latte',
  'Latte pistacjowe': 'Pistachio latte',

  /* Iced coffee */
  'Kawa mrożona klasyczna': 'Iced coffee classic',
  'podawana z bitą śmietaną': 'served with whipped cream',
  'Kawa mrożona orzechowa': 'Iced coffee nut',
  'krem orzechowy, kawa latte, syrop orzechowy, bita śmietana, sos orzechowy, posypka orzechowa':
    'nut cream, latte, nut syrup, whipped cream, nut sauce, nut sprinkle',
  'Kawa mrożona pistacjowa': 'Iced pistachio coffee',
  'kawa latte z kremem pistacjowym, bitą śmietaną, posypana kruszonymi prażonymi pistacjami':
    'latte with pistachio cream, whipped cream, topped with crushed roasted pistachios',
  'Kawa mrożona ze słonym karmelem': 'Iced coffee with salted caramel',
  'słony karmel, kawa latte, gałka lodów, bita śmietana, sos karmelowy':
    'salted caramel, latte, scoop of ice cream, whipped cream, caramel sauce',
  'Kawa affogato': 'Coffee affogato',
  'lody waniliowe lub pistacjowe zalane espresso':
    'vanilla or pistachio ice cream drenched in espresso',

  /* Matcha */
  'Matcha iced latte': 'Matcha iced latte',
  'Matcha iced truskawkowa': 'Matcha iced strawberry',
  'Matcha iced mango-marakuja': 'Matcha iced mango-passion fruit',
  'Matcha iced z białą czekoladą': 'Matcha iced with white chocolate',

  /* Cold drinks */
  'Lemoniada cytrusowa': 'Citrus lemonade',
  'Lemoniada różana': 'Rose lemonade',
  'Lemoniada truskawkowa': 'Strawberry lemonade',
  'Lemoniada marakuja': 'Passion fruit lemonade',
  'Lemoniada imbirowa': 'Ginger lemonade',
  'Pepsi / Mirinda / 7up / Tonic Schweppes': 'Pepsi / Mirinda / 7up / Tonic Schweppes',
  'Sok pomarańczowy / jabłkowy': 'Orange / apple juice',
  'Woda mineralna': 'Mineral water',
  'Piwo, napoje alkoholowe': 'Beer, alcoholic drinks',
  'o wybór zapytaj obsługę': 'please ask our staff',

  /* Ice cream desserts */
  'Deser lodowy owocowy lub czekoladowy': 'Fruit or chocolate ice cream dessert',
  'dwie gałki lodów, bita śmietana oraz dodatki — o szczegóły zapytaj obsługę':
    'two scoops of ice cream, whipped cream and toppings — please ask our staff',
  'Czekolada': 'Chocolate',
  'dwie gałki lodów, owoce i bita śmietana': 'two scoops of ice cream, fruit and whipped cream',

  /* Cocktails */
  'Aperol Spritz': 'Aperol Spritz',
  'Aperol, Prosecco, pomarańcza': 'Aperol, Prosecco, orange',
  'Aperol Summer Day': 'Aperol Summer Day',
  'Aperol, purée truskawka, sok z cytryny, purée mirabelka, tonik różany':
    'Aperol, strawberry purée, lemon juice, mirabelle purée, rose tonic',
  'Aperol Watermelon Love': 'Aperol Watermelon Love',
  'Aperol, purée marakuja, lemoniada arbuzowa': 'Aperol, passion fruit purée, watermelon lemonade',
  'Hugo Spritz': 'Hugo Spritz',
  'syrop z kwiatów czarnego bzu, Prosecco, cytryna, mięta': 'elderflower syrup, Prosecco, lemon, mint',
  'Fresh Berry Coco': 'Fresh Berry Coco',
  'Malibu, syrop poziomka, tonik różany': 'Malibu, wild strawberry syrup, rose tonic',
  'Pornstar Coco': 'Pornstar Coco',
  'Malibu, purée marakuja, syrop waniliowy, lemoniada cytrynowa':
    'Malibu, passion fruit purée, vanilla syrup, lemon lemonade',

  /* Teas */
  'Czarna': 'Black',
  'herbata indyjska z regionu Assam. Drobne listki, słodkawy aromat z kwiatową nutą.':
    'Indian tea from the Assam region. Small leaves, sweet aroma with a floral note.',
  'Earl Grey Blue': 'Earl Grey Blue',
  'czarna Ceylon z bławatkiem i olejkiem z bergamotki.':
    'black Ceylon with cornflower and bergamot oil.',
  'Zielona': 'Green',
  'z chińskiej prowincji Yunnan. Napar o złocistej barwie, delikatny klasyczny aromat.':
    "from China's Yunnan province. A golden brew with a delicate, classic aroma.",
  'Cytryna i imbir': 'Lemon and ginger',
  'zielona z imbirem, trawą cytrynową i skórką cytryny.':
    'green with ginger, lemongrass and lemon peel.',
  'Zaczarowany Ogród': 'Enchanted Garden',
  'jabłko, papaja, czarny bez, truskawka, słonecznik, bławatek.':
    'apple, papaya, elderberry, strawberry, sunflower, cornflower.',
  'Wiśnie w Rumie': 'Cherries in Rum',
  'jagody, wiśnie, hibiskus, ananas, rodzynki.':
    'blueberries, cherries, hibiscus, pineapple, raisins.',
  'Słodkie Tropiki': 'Sweet Tropics',
  'hibiskus, jabłko, ananas, płatki kokosowe, róża, banan — na bazie czarnej.':
    'hibiscus, apple, pineapple, coconut flakes, rose, banana — on a black tea base.',
  'Miłosny Krzew': 'Love Bush',
  'hibiskus, rodzynki, róża, czarny bez, maliny, bławatek.':
    'hibiscus, raisins, rose, elderberry, raspberries, cornflower.',
  'Grzaniec': 'Mulled',
  'cynamon, goździki, czarny bez, tarnina, czarna jagoda, aronia, głóg, jarzębina.':
    'cinnamon, cloves, elderberry, blackthorn, blueberry, chokeberry, hawthorn, rowan.',

  /* Pralines section */
  'Praliny · kolekcja': 'Pralines · collection',
  'Galeria przykładowych smaków pralin – pełna oferta dostępna na miejscu w lokalu.':
    'A gallery of sample praline flavours – the full selection is available on-site.',
  'Ręcznie robione, ': 'Handmade, ',
  'w małych partiach.': 'in small batches.',
  'Powstają w naszej manufakturze z prawdziwej pasji do czekolady i najwyższej jakości składników. Każda z nich to harmonijne połączenie rzemieślniczego kunsztu, głębokiego smaku i zachwycającej estetyki. To nie tylko doskonała słodka przyjemność, ale małe, czekoladowe dzieło sztuki.':
    'Made in our workshop with genuine passion for chocolate and the finest ingredients. Each praline is a harmonious blend of artisanal craft, deep flavour and captivating beauty. Not just an exquisite sweet treat, but a small chocolate work of art.',
  'smaków\nw kolekcji': 'flavours\nin the collection',
  'Aktualne menu pralin dostępne na miejscu': 'Current praline menu available on-site',
  'w Czekoladziarni — codziennie świeże, prosto z gabloty.':
    'at the chocolaterie — fresh every day, straight from the display.',
  'Zapytaj o dostępność': 'Ask about availability',

  /* Praline names */
  'Rum-Diplomatico': 'Rum-Diplomatico',
  'Jagoda-Wanilia': 'Blueberry-Vanilla',
  'Jabłko-Karmel': 'Apple-Caramel',
  'Orzech Włoski': 'Walnut',
  'Wiśnia': 'Cherry',
  'Kawa z Kardamonem': 'Coffee with Cardamom',
  'Banana Karmel': 'Banana Caramel',
  'Rum z Kokosem': 'Rum with Coconut',
  'Whisky Karmel': 'Whisky Caramel',
  'Pomarańcza i Czekolada': 'Orange & Chocolate',
  'Orzech Laskowy': 'Hazelnut',
  'Piernik': 'Gingerbread',
  'Róża & Pistacja': 'Rose & Pistachio',
  'Kokos': 'Coconut',
  'Mięta': 'Mint',
  'Yuzu': 'Yuzu',
  'Trufla Kokosowa': 'Coconut Truffle',
  'Malina': 'Raspberry',
  'Pistacja': 'Pistachio',
  'Mango-Marakuja': 'Mango-Passion Fruit',
  'Pomarańcze w Czekoladzie': 'Orange in Chocolate',

  /* Marquee */
  'Belgijska czekolada': 'Belgian chocolate',
  'Ręcznie robione': 'Handmade',
  'Od 2004 roku': 'Since 2004',
  'ul. Więzienna 31': 'Więzienna 31',
  'Limitowane serie sezonowe': 'Seasonal limited editions',

  /* Gallery */
  'Świeżo z naszej pracowni.': 'Fresh from our workshop.',
  'Instagram': 'Instagram',

  /* Testimonials */
  'Słowo o nas': 'A word about us',
  'Goście, których ': 'Guests we ',
  'pamiętamy.': 'remember.',
  'Najgęstsza, najgłębsza gorąca czekolada w mieście. Wracam tu od lat — i za każdym razem znajduję coś nowego w karcie.':
    "The thickest, richest hot chocolate in town. I've been coming back for years — and I always find something new on the menu.",
  'Klaudia M.': 'Klaudia M.',
  'Google · 5★': 'Google · 5★',
  'Brownie z wiśniami, dla którego warto przejechać pół kraju. Mała, klimatyczna kawiarnia w samym sercu Starego Miasta.':
    'A cherry brownie worth crossing half the country for. A small, atmospheric café right in the heart of the Old Town.',
  'Recenzja kukbuk.pl': 'Review by kukbuk.pl',
  'Magazyn kulinarny': 'Culinary magazine',
  'Praliny ręcznie robione, limitowane serie z matchą i pistacją — poziom mistrzowski. Idealne na prezent.':
    'Hand-made pralines, limited editions with matcha and pistachio — masterful level. Perfect for a gift.',
  'Tomasz K.': 'Tomasz K.',
  'Stały klient': 'Regular customer',
  'Bombonierki z naszym logo na konferencję firmową — goście byli zachwyceni. Obsługa profesjonalna, smak bezbłędny.':
    'Chocolate boxes with our logo for a corporate conference — guests were delighted. Professional service, flawless taste.',
  'Anna W.': 'Anna W.',
  'Zamówienie firmowe': 'Corporate order',

  /* Orders section */
  'Ciasta i torty na zamówienie': 'Cakes & Tarts on Order',
  'Twoja okazja, ': 'Your occasion, ',
  'nasza receptura.': 'our recipe.',
  'Każdego dnia w naszej witrynie czekają na Ciebie świeże ciasta – od klasycznych wypieków po sezonowe nowości, które idealnie komponują się z kawą czy gorącą czekoladą. Z myślą o osobach z celiakią zawsze oferujemy w 100% bezpieczne ciasta bezglutenowe, przygotowywane w osobnej pracowni. Wszystkie nasze wypieki możesz zamówić w całości (oferta poniżej). Tworzymy również personalizowane torty na wesela, chrzciny, komunie i urodziny – smak, dekorację oraz wycenę ustalamy indywidualnie.':
    'Every day, fresh cakes await you in our display — from classic bakes to seasonal novelties that pair perfectly with coffee or hot chocolate. For guests with coeliac disease, we always offer 100% safe gluten-free cakes, prepared in a separate kitchen. All our bakes can be ordered whole (menu below). We also create personalised cakes for weddings, christenings, communions and birthdays — flavour, decoration and pricing agreed individually.',
  'Zamówienia przyjmujemy telefonicznie lub przez Messenger!':
    'Orders taken by phone or via Messenger!',
  'Napisz na Messengerze': 'Message us on Messenger',

  /* Order form */
  'Imię i nazwisko': 'Full name',
  'E-mail': 'Email',
  'Telefon': 'Phone',
  'Data odbioru': 'Pick-up date',
  'Okazja': 'Occasion',
  'Wybierz okazję': 'Choose an occasion',
  'Opisz, co masz w głowie': 'Describe what you have in mind',
  'Liczba osób, smaki, alergeny, inspiracje, sposób pakowania…':
    'Number of guests, flavours, allergens, inspiration, packaging…',
  'Wysyłam…': 'Sending…',
  'Wyślij zapytanie': 'Send enquiry',
  'Wysyłając formularz, wyrażasz zgodę na kontakt w sprawie realizacji zamówienia.':
    'By submitting this form you agree to be contacted about fulfilling the order.',
  'Dziękujemy.': 'Thank you.',
  'Otrzymaliśmy Twoje zapytanie i wysłaliśmy potwierdzenie na Twój e-mail. Skontaktujemy się z Tobą w ciągu 24 godzin.':
    "We've received your enquiry and sent a confirmation to your email. We'll get back to you within 24 hours.",
  'Wyślij kolejne zapytanie': 'Send another enquiry',
  'Uzupełnij wszystkie wymagane pola.': 'Please fill in all required fields.',
  'Dziękujemy! Odpowiemy w ciągu 24 godzin.': "Thank you! We'll reply within 24 hours.",
  'Nie udało się wysłać zapytania. Spróbuj ponownie lub zadzwoń.':
    'Could not send your enquiry. Please try again or call us.',

  /* Order occasions */
  'Tort okolicznościowy': 'Occasion cake',
  'Bombonierka personalizowana': 'Personalised chocolate box',
  'Prezent firmowy': 'Corporate gift',
  'Ślub i wesele': 'Wedding',
  'Chrzest / komunia': 'Christening / communion',
  'Walentynki': "Valentine's Day",
  'Boże Narodzenie': 'Christmas',
  'Wielkanoc': 'Easter',
  'Inna okazja': 'Other occasion',

  /* Cakes menu */
  'Karta wypieków · 2026': 'Bakery menu · 2026',
  'Codzienna witryna, ': 'Daily display, ',
  'i całe tortownice.': 'and whole cake tins.',
  'Wszystkie poniższe wypieki są dostępne codziennie na porcje w witrynie oraz do zamówienia w całości. Ceny za tortownicę o średnicy 26 cm.':
    'All bakes below are available daily by the slice in our display and to order whole. Prices for a 26 cm tin.',
  'cena za tortownicę o śr. 26 cm': 'price per 26 cm tin',
  'wycena indywidualna': 'individual quote',

  /* Cakes categories */
  'Serniki': 'Cheesecakes',
  'Pieczone w formie 26 cm': 'Baked in a 26 cm tin',
  'Klasyczne receptury i autorskie warianty — każdy sernik wypiekany w naszej pracowni na zamówienie.':
    'Classic recipes and signature variations — each cheesecake baked to order in our workshop.',
  'Cytrynowy z białą czekoladą': 'Lemon with white chocolate',
  'Nowojorski z polewą czekoladową': 'New York with chocolate topping',
  'Dyniowy': 'Pumpkin',
  'Kajmakowy z gruszką karmelizowaną': 'Toffee with caramelised pear',
  'Pomarańczowy': 'Orange',
  'Cytrynowy z musem truskawkowym': 'Lemon with strawberry mousse',
  'Bounty': 'Bounty',
  'Snickers': 'Snickers',
  'Truskawkowy z mascarpone': 'Strawberry with mascarpone',
  'Oreo': 'Oreo',
  'Bananowy z czekoladą': 'Banana with chocolate',
  'Pistacjowy': 'Pistachio',

  'Nasze klasyki': 'Our classics',
  'Pieczone codziennie': 'Baked daily',
  'Wypieki, które nigdy nie wychodzą z mody. Bezy, szarlotki, brownie i miodownik — receptury dopracowywane latami.':
    'Bakes that never go out of style. Meringues, apple pies, brownies and honey cake — recipes perfected over years.',
  'Szarlotka z bezą': 'Apple pie with meringue',
  'Wiśniowe z bezą': 'Cherry with meringue',
  'Szarlotka klasyczna': 'Classic apple pie',
  'Brownie z wiśniami': 'Brownie with cherries',
  'Miodownik': 'Honey cake',
  'Malinowa chmurka': 'Raspberry cloud',
  'Marchewkowe': 'Carrot cake',
  'Red Velvet': 'Red Velvet',

  'Tarty': 'Tarts',
  'Kruche spody, świeże owoce': 'Crisp bases, fresh fruit',
  'Sezonowe kompozycje na kruchym spodzie — od klasycznej pistacjowej z malinami po tiramisu i banoffee.':
    'Seasonal compositions on a shortcrust base — from classic pistachio with raspberries to tiramisu and banoffee.',
  'Pistacjowa z malinami': 'Pistachio with raspberries',
  'Oreo z borówkami i malinami': 'Oreo with blueberries and raspberries',
  'Śliwka w czekoladzie': 'Plum in chocolate',
  'Tiramisu': 'Tiramisu',
  'Banoffee': 'Banoffee',

  'Torty': 'Cakes',
  'Na wesela, chrzciny, urodziny': 'For weddings, christenings, birthdays',
  'Smak, rozmiar i dekorację ustalamy indywidualnie z każdym klientem. Poniżej przykładowe smaki — wycena po rozmowie.':
    'Flavour, size and decoration agreed individually with each client. Sample flavours below — pricing after consultation.',
  'na zamówienie': 'made to order',
  'Czekoladowy z wiśniami': 'Chocolate with cherries',
  'Śmietankowy z truskawkami': 'Cream with strawberries',
  'Kokosowy z malinami i brzoskwiniami': 'Coconut with raspberries and peaches',
  'Pistacja z maliną': 'Pistachio with raspberry',
  'Tropikalny': 'Tropical',
  'Leśny mech z truskawką, szpinakiem i miętą':
    'Forest moss with strawberry, spinach and mint',
  'Smaki tortów, wielkość i dekoracje ustalamy indywidualnie wg. życzenia klienta.':
    "Cake flavours, size and decorations agreed individually per client's wishes.",

  /* Contact */
  'Wpadnij ': 'Drop by ',
  'na chwilę': 'for a moment',
  'Adres': 'Address',
  'Stare Miasto · obok Rynku': 'Old Town · next to the Market Square',
  'Godziny otwarcia': 'Opening hours',
  'Poniedziałek – Czwartek': 'Monday – Thursday',
  'Piątek – Sobota': 'Friday – Saturday',
  'Niedziela': 'Sunday',
  'Facebook': 'Facebook',
  'TikTok': 'TikTok',
  '© {year} Czekoladziarnia Wrocław · Ręcznie tworzona od 2004':
    '© {year} Czekoladziarnia Wrocław · Hand-crafted since 2004',
  'ul. Więzienna 31 · Wrocław': 'Więzienna 31 · Wrocław',

  /* Newsletter */
  'Limitowane serie': 'Limited editions',
  'Wiedz pierwszy, ': 'Be the first to know ',
  'kiedy znikają z gablot.': 'when they leave the display.',
  'Sezonowe smaki gorącej czekolady, limitowane praliny i nowości — bez spamu, raz na jakiś czas.':
    'Seasonal hot chocolate flavours, limited pralines and news — no spam, only from time to time.',
  'twoj@email.pl': 'you@example.com',
  'Zapisuję…': 'Signing up…',
  'Zapisz mnie': 'Sign me up',
  '✓ Dziękujemy. Do zobaczenia w skrzynce.': '✓ Thank you. See you in your inbox.',
  'Witamy! Sprawdź skrzynkę.': 'Welcome! Check your inbox.',
  'Jesteś już zapisany. Do zobaczenia w skrzynce.': "You're already subscribed. See you in your inbox.",
  'Podaj poprawny adres e-mail.': 'Please enter a valid email address.',
  'Nie udało się zapisać. Spróbuj ponownie.': 'Could not sign up. Please try again.',

  /* Misc */
  'Poprzednie': 'Previous',
  'Następne': 'Next',
  'SCROLL': 'SCROLL',
  'Wolisz porozmawiać?': 'Prefer to talk?',
  'Bombonierka autorska': 'Signature chocolate box',
  'Ręcznie pakowana': 'Hand-packed',
  'Pakowana ręcznie, dla Ciebie': 'Packed by hand, for you',
};

/* ------------------------------------------------------------- */
/*  Context + hook                                               */
/* ------------------------------------------------------------- */

const LanguageContext = createContext({
  lang: 'pl',
  setLang: () => {},
  t: (s) => s,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'pl';
    return localStorage.getItem('lang') === 'en' ? 'en' : 'pl';
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    if (typeof window !== 'undefined') localStorage.setItem('lang', l);
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (str) => {
      if (lang === 'pl' || str == null) return str;
      if (typeof str !== 'string') return str;
      return EN[str] ?? str;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);

/* ------------------------------------------------------------- */
/*  Flag icons                                                    */
/* ------------------------------------------------------------- */

export const FlagPL = ({ size = 16 }) => (
  <svg width={size} height={(size * 5) / 8} viewBox="0 0 8 5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ display: 'inline-block', borderRadius: 1 }}>
    <rect width="8" height="5" fill="#fff" />
    <rect y="2.5" width="8" height="2.5" fill="#DC143C" />
  </svg>
);

export const FlagGB = ({ size = 16 }) => (
  <svg width={size} height={(size * 30) / 60} viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ display: 'inline-block', borderRadius: 1 }}>
    <clipPath id="t">
      <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
    </clipPath>
    <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
    <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
    <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4" />
    <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
    <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
  </svg>
);

/* ------------------------------------------------------------- */
/*  Toggle component                                              */
/* ------------------------------------------------------------- */

export function LanguageToggle({ testId = 'lang-toggle' }) {
  const { lang, setLang } = useLang();
  const isEN = lang === 'en';
  return (
    <div
      role="group"
      aria-label="Language"
      className="inline-flex items-center rounded-full border border-white/15 bg-[#0a0a0a]/60 backdrop-blur-md p-1 select-none"
    >
      <button
        type="button"
        data-testid={`${testId}-pl`}
        onClick={() => setLang('pl')}
        aria-pressed={!isEN}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] tracking-[0.16em] uppercase font-semibold transition-all duration-500 ${
          !isEN
            ? 'bg-[#c07e5b] text-[#0a0a0a] shadow-[0_2px_10px_rgba(192,126,91,0.35)]'
            : 'text-zinc-400 hover:text-white'
        }`}
      >
        <FlagPL size={14} /> PL
      </button>
      <button
        type="button"
        data-testid={`${testId}-en`}
        onClick={() => setLang('en')}
        aria-pressed={isEN}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] tracking-[0.16em] uppercase font-semibold transition-all duration-500 ${
          isEN
            ? 'bg-[#c07e5b] text-[#0a0a0a] shadow-[0_2px_10px_rgba(192,126,91,0.35)]'
            : 'text-zinc-400 hover:text-white'
        }`}
      >
        <FlagGB size={14} /> EN
      </button>
    </div>
  );
}
